import Model from "./base/model";

class SimulationIntegraOrdersAddresses extends Model {
  resourceName() {
    return "simulation_integra_orders_addresses";
  }

  fields() {
    return {
      simulation_integra_order_id: "",
      address_id: "",
      percentage_weight_shipping_value: "",
      weight_shipping_value: "",
      rates: "",
      simulation_integra_order: { jsonApi: "hasOne", type: "simulation_integra_orders"},
      address: { jsonApi: "hasOne", type: "addresses"},
    };
  }

}

export default new SimulationIntegraOrdersAddresses();
